import React from 'react';
import styled from 'styled-components';

interface PictureProps {
  className?: string;
  src: string;
}

const Container = styled.div`
  border: 2px solid #F87B15;
  border-radius: 1.5rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

const Image = styled.img`
  padding: 1rem 0;
  height: 100%;
`;

export const Picture: React.FC<PictureProps> = ({ className, src }) => {
  return (
    <Container className={className}>
      <Image src={src} alt="" />
    </Container>
  );
};